__turbopack_context__.v({
  "circle": "iconButton-module-scss-module__VAlLia__circle",
  "disabled": "iconButton-module-scss-module__VAlLia__disabled",
  "ghost": "iconButton-module-scss-module__VAlLia__ghost",
  "icon": "iconButton-module-scss-module__VAlLia__icon",
  "iconButton": "iconButton-module-scss-module__VAlLia__iconButton",
  "inverted": "iconButton-module-scss-module__VAlLia__inverted",
  "muted": "iconButton-module-scss-module__VAlLia__muted",
  "neutral": "iconButton-module-scss-module__VAlLia__neutral",
  "primary": "iconButton-module-scss-module__VAlLia__primary",
  "secondary": "iconButton-module-scss-module__VAlLia__secondary",
  "tertiary": "iconButton-module-scss-module__VAlLia__tertiary",
  "withoutPadding": "iconButton-module-scss-module__VAlLia__withoutPadding",
});
